import React from "react";

// Atrapa errores de render de cualquier componente hijo.
// Sin esto, un crash desmonta toda la app y queda pantalla en blanco.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error, info: null };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary capturó un error:", error, info);
    this.setState({ info });
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    const { error, info } = this.state;
    const errorText = error
      ? error.stack || error.toString()
      : "Error desconocido";

    return (
      <div
        style={{
          padding: "1.5rem",
          fontFamily: "system-ui, -apple-system, sans-serif",
          maxWidth: 900,
          margin: "0 auto",
        }}
      >
        <h2 style={{ color: "#a00", marginTop: 0 }}>
          Ocurrió un problema al mostrar esta página
        </h2>
        <p>
          Por favor recarga la página. Si el error vuelve a aparecer, envía
          esta información al equipo de soporte:
        </p>
        <button
          onClick={this.handleReload}
          style={{
            padding: "0.6rem 1.2rem",
            background: "#a00",
            color: "white",
            border: "none",
            borderRadius: 4,
            fontSize: "1rem",
            cursor: "pointer",
            marginBottom: "1.5rem",
          }}
        >
          Recargar página
        </button>
        <details
          open
          style={{
            background: "#f7f7f7",
            border: "1px solid #ddd",
            borderRadius: 4,
            padding: "1rem",
            marginTop: "1rem",
          }}
        >
          <summary style={{ cursor: "pointer", fontWeight: "bold" }}>
            Detalle técnico (para el equipo)
          </summary>
          <pre
            style={{
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              color: "#a00",
              marginTop: "0.5rem",
              fontSize: "0.9rem",
            }}
          >
            {errorText}
          </pre>
          {info && info.componentStack && (
            <pre
              style={{
                whiteSpace: "pre-wrap",
                wordBreak: "break-word",
                color: "#555",
                fontSize: "0.8rem",
              }}
            >
              {info.componentStack}
            </pre>
          )}
        </details>
      </div>
    );
  }
}

export default ErrorBoundary;
